import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./MealsPop.module.scss";
import Select from "react-select";
import { useForm } from "react-hook-form";
import {
  useAddMealMutation,
  useUpdateMealMutation,
} from "../../../store/services/mealService";
import { useAddCoolerBagMutation } from "../../../store/services/refundService";
import toast from "react-hot-toast";

const mealOptions = [
  { value: "Breakfast", label: "Breakfast" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
];

const CoolerBag = ({ title, modalOpen, setModalOpen, edit }) => {
 

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      orderID: edit?.orderID || "",
      amount: edit?.amount || "",
      reason: edit?.reason || "",
    },
  });
  const [selectedMeals, setSelectedMeals] = useState(
    edit?.mealType
      ? mealOptions.filter((option) => edit.mealType.includes(option.value))
      : []
  );
  const [addMeal, { isLoading: isAdding }] = useAddCoolerBagMutation();
  const [updateMeal, { isLoading: isUpdating }] = useUpdateMealMutation();

  // Submit handler
  const onSubmit = async (data) => {
    try {
      data.isCharge = data.isCharge === "true";
      if (edit !== null) {
        // Update existing meal
        await updateMeal({
          mealId: edit._id,
          updatedData: data,
        });
      } else {
        await addMeal(data).unwrap(); // Call deleteMeal and handle success
      }
      setModalOpen(false);
      // return toast.success(`Meal ${edit ? "updated" : "Added"} successfully`);
      return toast.success("Cooler bag refunded successfully");
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.MealsPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Col lg="12" md="12" className="my-2">
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Order ID
                  </label>
                  <input
                    type="number"
                    placeholder="Enter order ID"
                    className="form-control"
                    {...register("orderID", {
                      required: "Please enter order ID",
                      //min: 1,
                    })}
                  />
                  {errors.orderID && (
                    <span className="text-danger">
                      {errors.orderID.message}
                    </span>
                  )}
                </div>

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Amount
                  </label>
                  <input
                    type="number"
                    placeholder="Enter amount"
                    className="form-control"
                    {...register("amount", {
                      required: "Please enter amount",
                      //min: 1,
                    })}
                  />
                  {errors.amount && (
                    <span className="text-danger">{errors.amount.message}</span>
                  )}
                </div>

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Reason
                  </label>
                  <input
                    type="text"
                    placeholder="Enter reason"
                    className="form-control"
                    {...register("reason", {
                      required: "Please enter reason",
                      // validate: (value) => {
                      //   if (/^\s/.test(value)) {
                      //     return "Name cannot start with a space";
                      //   }
                      //   if (/[^a-zA-Z0-9\s]/.test(value)) {
                      //     return "Name cannot include special characters or emojis";
                      //   }
                      //   return true;
                      // },
                    })}
                  />
                  {errors.reason && (
                    <span className="text-danger">{errors.reason.message}</span>
                  )}
                </div>

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Transaction Type
                  </label>
                  <div className="d-flex gap-3 ps-2 pt-1">
                    <div className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="true"
                        id="charge"
                        {...register("isCharge", {
                          required: "Please select a type",
                        })}
                      />
                      <label className="form-check-label" htmlFor="charge">
                        Charge
                      </label>
                    </div>
                    <div className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        value="false"
                        id="refund"
                        defaultChecked={true}
                        {...register("isCharge", {
                          required: "Please select a type",
                        })}
                      />
                      <label className="form-check-label" htmlFor="refund">
                        Refund
                      </label>
                    </div>
                  </div>
                  {errors.isCharge && (
                    <span className="text-danger ps-2">
                      {errors.isCharge.message}
                    </span>
                  )}
                </div>
              </Col>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CoolerBag;
